import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Top from '../navigation/top';
import Autocomplete from '../form/autocomplete';
import { FormRow } from '../form/formField';

import util from '../../lib/util';
import style from './style.css';

const initialState = {};

@observer
class DealerEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { dealerStore, brandStore } = this.props.stores;
        dealerStore.load('', false, { query: { customerno: props.customerno } });
        brandStore.load();
        const { brands } = brandStore;
        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: [
                    {
                        name: 'customerno',
                        label: 'Customer #',
                        type: 'number',
                        readonly: true,
                        help: 'Field is imported from Visma: "CustomerNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'name',
                        label: 'Customer name',
                        type: 'text',
                        readonly: true,
                        help: 'Field is imported from Visma: "Name" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'emailaddress',
                        label: 'Invoice email',
                        type: 'text',
                        readonly: true,
                        help: 'Field is imported from Visma: "EmailAddress" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'email',
                        label: 'Login email',
                        type: 'text',
                        readonly: true,
                        help: 'Field is imported from Visma: "ZUsrRating" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'repairEmail',
                        label: 'Repair notification email',
                        type: 'text',
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'dealerLevel',
                        label: 'Dealer level',
                        type: 'text',
                        readonly: true,
                        help: 'Field is imported from Visma: "DealerLevel" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'brands',
                        label: 'Brands',
                        type: 'object',
                        readonly: false,
                        // keys: brands.map(b => b.brandno),
                        // fields: [
                        //     {
                        //         namePrefix: 'brands.',
                        //         nameSuffix: '.allowed',
                        //         type: 'checkbox',
                        //         readonly: false,
                        //         help: 'Field is DealerWeb only.',
                        //     },
                        // ],
                    },
                    {
                        name: 'brandCombos',
                        label: 'Brand combos',
                        type: 'object',
                        readonly: false,
                        // keys: brands.map(b => b.brandno),
                        // fields: [
                        //     {
                        //         namePrefix: 'brands.',
                        //         nameSuffix: '.allowed',
                        //         type: 'checkbox',
                        //         readonly: false,
                        //         help: 'Field is DealerWeb only.',
                        //     },
                        // ],
                    },
                    {
                        name: 'hasAccessToCombos',
                        label: 'Has access to combos',
                        type: 'checkbox',
                        value: 1,
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'termsAndConditions',
                        label: 'Terms and conditions',
                        type: 'object',
                        readonly: true,
                        fields: [
                            {
                                namePrefix: 'termsAndConditions.',
                                nameSuffix: '.acceptedDate',
                                type: 'text',
                                readonly: true,
                                help: 'Field is DealerWeb only.',
                            },
                            {
                                namePrefix: 'termsAndConditions.',
                                nameSuffix: '.acceptedTerms',
                                type: 'text',
                                readonly: true,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                    },
                    {
                        name: 'currency',
                        label: 'Currency',
                        type: 'text',
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'pricelistno',
                        label: 'Pricelist #',
                        type: 'text',
                        readonly: false,
                        help: 'Field is imported from Visma: "PricelistNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'inboxSignature',
                        label: 'Inbox signature',
                        type: 'textarea',
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'settings',
                        label: 'Settings',
                        type: 'object',
                        keys: ['language', 'darkmode', 'inboxEmailNotifications'],
                        fields: [
                            {
                                namePrefix: 'settings.',
                                // nameSuffix: '.allowed',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                    },
                ],
            },
            {
                tabname: 'Login',
                icon: 'fas fa-sign-in-alt',
                fields: [
                    {
                        name: 'confirmed',
                        label: 'Confirmed',
                        type: 'checkbox',
                        value: 1,
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'approved',
                        label: 'Approved',
                        type: 'checkbox',
                        value: 1,
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'last_login',
                        label: 'Last login',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from all emails and is DealerWeb only.',
                    },
                    {
                        name: 'current_login_failed',
                        label: 'Current logins failed',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from all emails and is DealerWeb only.',
                    },
                    {
                        name: 'visits',
                        label: 'Visits',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from all emails and is DealerWeb only.',
                    },
                    {
                        name: 'activity',
                        label: 'Activity',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from all emails and is DealerWeb only.',
                    },
                    {
                        name: 'last_activity',
                        label: 'Last activity',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from all emails and is DealerWeb only.',
                    },
                    {
                        name: 'isOnline',
                        label: 'Is online',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from all emails and is DealerWeb only.',
                    },
                    {
                        name: 'emails',
                        label: 'Login emails',
                        type: 'object',
                        help: 'Field is DealerWeb only.',
                        readonly: true,
                        readonlyRef: {
                            current_login_failed: false,
                        },
                    },
                ],
            },
            {
                tabname: 'Delivery',
                icon: 'fas fa-truck',
                fields: [
                    {
                        name: 'deliveryname',
                        label: 'Delivery name',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'deliveryaddress1',
                        label: 'Delivery address',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'deliverypostcode',
                        label: 'Delivery post code',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'deliverypostoffice',
                        label: 'Delivery post office',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                    {
                        name: 'country',
                        label: 'Country',
                        type: 'text',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".',
                    },
                ],
            },
            {
                tabname: 'ConsumerWeb',
                icon: 'fas fa-store',
                fields: [
                    {
                        name: 'locator',
                        label: 'Dealer locator',
                        type: 'checkbox',
                        value: 1,
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'acceptConsumerOrders',
                        label: 'Accept consumer orders',
                        type: 'checkbox',
                        value: 1,
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'store',
                        label: 'Store',
                        type: 'object',
                        keys: ['name', 'address1', 'address2', 'zip', 'city', 'country', 'phone', 'fax', 'email', 'url',
                            'opening_hours_mon', 'opening_hours_tue', 'opening_hours_wed', 'opening_hours_thu',
                            'opening_hours_fri', 'opening_hours_sat', 'opening_hours_sub'],
                        fields: [
                            {
                                namePrefix: 'store.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                    },
                    {
                        name: 'geo',
                        label: 'Geo',
                        type: 'object',
                        keys: ['lat', 'lon', 'updated'],
                        fields: [
                            {
                                namePrefix: 'geo.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                    },
                    {
                        name: 'google_maps_lookup',
                        label: 'Google maps lookup',
                        type: 'object',
                        fields: [
                            {
                                namePrefix: 'google_maps_lookup.',
                                type: 'text',
                                readonly: true,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                    },
                ],
            },
            {
                tabname: 'Repair',
                icon: 'fas fa-tools',
                fields: [
                    {
                        name: 'shipping',
                        label: 'Shipping',
                        type: 'object',
                        keys: ['addresses', 'contacts'],
                        fields: [
                            {
                                namePrefix: 'shipping.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                    },
                ],
            },
            {
                tabname: 'Basket',
                icon: 'fas fa-shopping-cart',
                fields: [
                    {
                        name: 'basketQty',
                        label: 'Basket qty',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from Basket and is DealerWeb only.',
                    },
                    {
                        name: 'basketTotal',
                        label: 'Basket total',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from Basket and is DealerWeb only.',
                    },
                    {
                        name: 'basketCurrency',
                        label: 'Basket currency',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from Basket and is DealerWeb only.',
                    },
                    {
                        name: 'psBasketQty',
                        label: 'PS Basket qty',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from Basket and is DealerWeb only.',
                    },
                    {
                        name: 'psBasketTotal',
                        label: 'PS Basket total',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from Basket and is DealerWeb only.',
                    },
                    {
                        name: 'psBasketCurrency',
                        label: 'PS Basket currency',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is accumulated from Basket and is DealerWeb only.',
                    },

                    {
                        name: 'basket',
                        label: 'Basket content',
                        type: 'object',
                        help: 'Field is DealerWeb only.',
                        fields: [
                            {
                                namePrefix: 'basket.',
                                nameSuffix: '.content',
                                type: 'object',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                                view: (val) => {
                                    const keys = Object.keys(val);
                                    return keys.map((key) => {
                                        const line = val[key];
                                        return (
                                            <li>
                                                {line.qty} x {line.name} {line.currency} {util.format(line.qty * line.price, 2)}
                                                <small class='ml-2 text-muted'>{line.date} {line.addedFrom}</small>
                                            </li>
                                        );
                                    });
                                },
                            },
                            {
                                namePrefix: 'basket.',
                                nameSuffix: '.content-preSale',
                                type: 'object',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                                view: (val) => {
                                    const keys = Object.keys(val);
                                    return keys.map((key) => {
                                        const line = val[key];
                                        return (
                                            <li>
                                                {line.qty} x {line.name} {line.currency} {util.format(line.qty * line.price, 2)}
                                                <small class='ml-2 text-muted'>{line.date} {line.addedFrom}</small>
                                            </li>
                                        );
                                    });
                                },
                            },
                        ],
                    },

                    {
                        name: 'backorders',
                        label: 'Backorders',
                        type: 'object',
                        fields: [
                            {
                                namePrefix: 'backorders.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                                view: (val) => {
                                    return val.map((line) => {
                                        return (
                                            <li>
                                                {line.qty} x {line.name} {line.currency} {util.format(line.qty * line.price, 2)}
                                                <small class='ml-2 text-muted'>{line.orderdate} {line.yourref}</small>
                                            </li>
                                        );
                                    });
                                },
                            },
                        ],
                        readonly: true,
                        help: 'Field is imported from Visma... TODO!',
                    },
                    {
                        name: 'backorderDeleteReq',
                        label: 'Backorder delete requests',
                        type: 'object',
                        fields: [
                            {
                                namePrefix: 'backorderDeleteReq.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                        help: 'Field is DealerWeb only.',
                    },
                ],
            },
            {
                tabname: 'Agent',
                icon: 'fas fa-skull-crossbones',
                fields: [
                    {
                        name: 'is_agent',
                        label: 'Is agent',
                        type: 'checkbox',
                        value: 1,
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'agent_dealers',
                        label: 'Agent dealers',
                        type: 'object',
                        view: (val) => {
                            const opts = {
                                placeholder: 'Search for dealers...',
                                value: val,
                                valueDisplayMap: v => <span>
                                    <span class='font-weight-light'>{v.customerno}:</span> {v.name}
                                </span>,
                                autocompleteList: dealerStore.searchResults,
                                oninput: (e) => {
                                    clearTimeout(this.searchTimer);
                                    this.searchTimer = setTimeout(async () => {
                                        dealerStore.search(e.target.value);
                                    }, 500);
                                },
                                addElement: (idx) => {
                                    dealerStore.addElement(idx, 'dealer', 'agent_dealers');
                                    dealerStore.resetSearch();
                                },
                                removeElement: (id) => {
                                    dealerStore.removeElement(id, 'dealer', 'agent_dealers');
                                    dealerStore.resetSearch();
                                },
                                handleKeydown: (e) => {
                                    if (e.key === 'ArrowDown') {
                                        if (dealerStore.totalSearch === 0) {
                                            dealerStore.search(e.target.value);
                                        }
                                        dealerStore.incSearchSelectIdx();
                                    } else if (e.key === 'ArrowUp') {
                                        dealerStore.decSearchSelectIdx();
                                    } else if (e.key === 'Enter') {
                                        dealerStore.addElement(0, 'dealer', 'agent_dealers');
                                        dealerStore.resetSearch();
                                    } else if (e.key === 'Escape') {
                                        dealerStore.resetSearch();
                                    }
                                },
                                currentIdx: dealerStore.searchSelectIdx,
                                currentId: dealerStore.searchSelectId,
                                total: dealerStore.totalSearch,
                            };
                            return <Autocomplete {...opts} />;
                        },
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                ],
            },
            {
                tabname: 'Advanced',
                icon: 'fas fa-cogs',
                fields: [
                    {
                        name: 'offline',
                        label: 'Offline / Deleted',
                        type: 'checkbox',
                        value: 1,
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'inactiveyesno',
                        label: 'Inactive',
                        type: 'checkbox',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "InActiveYesNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv"',
                    },
                    {
                        name: 'customergrpno',
                        label: 'Customer grp',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "CustomerGrpNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv"',
                    },
                    {
                        name: 'customertype',
                        label: 'Customer type',
                        type: 'number',
                        value: 1,
                        readonly: true,
                        help: 'Field is imported from Visma: "CustomerTypeNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv"',
                    },
                    {
                        name: 'favorite',
                        label: 'Favorite',
                        type: 'object',
                        value: 1,
                        fields: [
                            {
                                namePrefix: 'favorite.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'pushNotifications',
                        label: 'pushNotifications',
                        type: 'object',
                        value: 1,
                        fields: [
                            {
                                namePrefix: 'pushNotifications.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                        help: 'Field is DealerWeb only.',
                    },
                    {
                        name: 'videos',
                        label: 'videos',
                        type: 'object',
                        value: 1,
                        fields: [
                            {
                                namePrefix: 'videos.',
                                type: 'text',
                                readonly: false,
                                help: 'Field is DealerWeb only.',
                            },
                        ],
                        help: 'Field is DealerWeb only.',
                    },
                ],
            },
        ];
    }

    updateField = async (customerno, field, value) => {
        const { dealerStore } = this.props.stores;
        dealerStore.updateField(customerno, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(customerno, field, value);
        }, 500);
    }

    async doUpdateField(customerno, field, value) {
        const { dealerStore } = this.props.stores;
        await dealerStore.saveField(customerno, field, value);
    }

    // formRow(field) {
    //     const { dealerStore } = this.props.stores;
    //     const { dealer, saved } = dealerStore;

    //     if (!field.view && field.type === 'object' && typeof dealer[field.name] === 'object') {
    //         const keys = field.keys || Object.keys(dealer[field.name]);

    //         return (
    //             <div class='form-group row'>
    //                 <label for={`input${field.name}`} class='col-sm-2 col-form-label'>{field.label || field.name}</label>
    //                 <div class='col-sm-10'>
    //                     {keys.map((key) => {
    //                         if (field.fields) {
    //                             return field.fields.map((f, idx) => <FormField
    //                                 field={{
    //                                     name: key,
    //                                     idx,
    //                                     ...f,
    //                                     updateField: this.updateField,
    //                                     updateFieldId: 'customerno',
    //                                 }}
    //                                 object={dealer}
    //                                 saved={saved}
    //                             />);
    //                         }
    //                         return <FormField
    //                             field={{
    //                                 name: key,
    //                                 ...field,
    //                                 updateField: this.updateField,
    //                                 updateFieldId: 'customerno',
    //                             }}
    //                             object={dealer}
    //                             saved={saved}
    //                         />;
    //                     })}
    //                 </div>
    //             </div>
    //         );
    //     }
    //     return <FormField
    //         field={{
    //             ...field,
    //             updateField: this.updateField,
    //             updateFieldId: 'customerno',
    //         }}
    //         object={dealer}
    //         saved={saved}
    //     />;
    // }

    render(props) {
        const { dealerStore } = this.props.stores;
        const { dealer, saved } = dealerStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/dealers' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {dealer.customerno}: {dealer.name}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/dealers/${props.customerno}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={dealer}
                            saved={saved}
                            updateField={this.updateField}
                            updateFieldId={'customerno'}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default DealerEdit;



// WEBPACK FOOTER //
// ./components/dealers/edit.js